import React, { useEffect, useState } from 'react';
import {
    Box, Typography, Grid, TextField, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Button, TablePagination, useMediaQuery
} from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useDeadline } from "../../../../contexts/DeadlineContext";
const AffiliationCpAttendanceReport = () => {
    const history = useHistory();
    const eventid = localStorage.getItem('eventid');
     const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
     const gradientBackground = '#05597D';
    const [participantAttendanceData, setParticipantAttendanceData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchDate, setSearchDate] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const isMobile = useMediaQuery('(max-width:600px)');

    useEffect(() => {
        axios.get(`api/conference-affilition-attendi/${eventid}`)
            .then(res => {
                if (res.status === 200) {
                    const filtered = res.data.cpAttendence.filter(item => item.event_affiliate_status === 1);
                    setParticipantAttendanceData(filtered);
                } else {
                    alert('Error: Check API Something Wrong');
                }
            })
            .catch(error => {
                console.error('API Error:', error);
            });
    }, [eventid]);

    const handleDownloadCSV = () => {
        const csvContent = [
            ['ID', 'Name', 'Conference', 'DateTime'],
            ...participantAttendanceData.map(item => [
                item.cp_data.id,
                item.cp_data.participant_name,
                item.c_data.conference_name,
                item.datetime
            ])
        ]
            .map(e => e.join(','))
            .join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = 'affiliation_attendance.csv';
        a.click();
        URL.revokeObjectURL(url);
    };

    const filteredRows = participantAttendanceData.filter(row => {
        const nameMatch = row.cp_data.participant_name.toLowerCase().includes(searchTerm.toLowerCase());
        const dateMatch = searchDate === '' || row.datetime.startsWith(searchDate);
        return nameMatch && dateMatch;
    });

    const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <div style={{ marginTop: '5%', width: '100vw', marginLeft: '0%' }}>
            <Box sx={{ minHeight: '100vh', padding: 2 }}>
                <Typography sx={{ margin: '2%', }} variant="h4" gutterBottom align="center">Conference Affiliation Attendance</Typography>
                <Button
                    variant="contained"
                    color="success"
                    sx={{ float: 'right',background: abstractHomeSetup.color_code_two || gradientBackground, }}
                    onClick={() => history.goBack()}
                >
                    Back
                </Button>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Filter By Name"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Filter By Date"
                            type="date"
                            value={searchDate}
                            onChange={(e) => setSearchDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>

                {participantAttendanceData.length > 0 && (
                    <Button
                        variant="contained"
                        color="success"
                        startIcon={<FileDownloadIcon />}
                        sx={{ float: 'right' ,background: abstractHomeSetup.color_code_two || gradientBackground,}}
                        onClick={handleDownloadCSV}
                    >
                        Download CSV
                    </Button>
                )}

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {isMobile ? (
                                    <TableCell colSpan={4} align="center"><strong>Attendance Details</strong></TableCell>
                                ) : (
                                    <>
                                        <TableCell><strong>#</strong></TableCell>
                                        <TableCell><strong>Participant ID</strong></TableCell>
                                        <TableCell><strong>Name</strong></TableCell>
                                        <TableCell><strong>Conference</strong></TableCell>
                                        <TableCell><strong>Affiliated</strong></TableCell>
                                        <TableCell><strong>Date & Time</strong></TableCell>
                                    </>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedRows.map((row, idx) => (
                                <TableRow key={idx}>
                                    {isMobile ? (
                                        <TableCell colSpan={4}>
                                             <Box><strong>ID:</strong> {idx + 1}</Box>
                                            <Box><strong>ID:</strong> {row.cp_data.id}</Box>
                                            <Box><strong>Name:</strong> {row.cp_data.participant_name}</Box>
                                            <Box><strong>Conference:</strong> {row.c_data.conference_name}: {row.c_data.conference_day}</Box>
                                            <Box><strong>Conference:</strong> {row.event_affiliate_status === 1 ? 'Affiliated' : 'Not Affiliated'}</Box>
                                            <Box><strong>Datetime:</strong> {row.datetime}</Box>
                                        </TableCell>
                                    ) : (
                                        <>
                                            <TableCell>{idx + 1}</TableCell>
                                            <TableCell>{row.cp_data.id}</TableCell>
                                            <TableCell>{row.cp_data.participant_name}</TableCell>
                                            <TableCell>{row.c_data.conference_name}: {row.c_data.conference_day}</TableCell>
                                            <TableCell> {row.event_affiliate_status === 1 ? 'Affiliated' : 'Not Affiliated'}</TableCell>
                                           
                                            <TableCell>{row.datetime}</TableCell>
                                        </>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                    <TablePagination
                        component="div"
                        count={filteredRows.length}
                        page={page}
                        onPageChange={(e, newPage) => setPage(newPage)}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={(e) => {
                            setRowsPerPage(parseInt(e.target.value, 10));
                            setPage(0);
                        }}
                    />
                </TableContainer>
            </Box>
        </div>
    );
};

export default AffiliationCpAttendanceReport;
